/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authcallbackclaimerrorheading4Inputs */

const en_authcallbackclaimerrorheading4 = /** @type {(inputs: Authcallbackclaimerrorheading4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load your diagnostic`)
};

const pt_authcallbackclaimerrorheading4 = /** @type {(inputs: Authcallbackclaimerrorheading4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o seu diagnóstico`)
};

/**
* | output |
* | --- |
* | "Couldn't load your diagnostic" |
*
* @param {Authcallbackclaimerrorheading4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authcallbackclaimerrorheading4 = /** @type {((inputs?: Authcallbackclaimerrorheading4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authcallbackclaimerrorheading4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authcallbackclaimerrorheading4(inputs)
	return pt_authcallbackclaimerrorheading4(inputs)
});
export { authcallbackclaimerrorheading4 as "authCallbackClaimErrorHeading" }